<template>
  <svg width="28" height="16" xmlns="http://www.w3.org/2000/svg">
    <path d="M27.68 1.17a1.094 1.094 0 00-1.546-.003l-11.36 11.337a1.095 1.095
      0 01-1.548 0L1.866 1.166A1.094 1.094 0 10.321 2.716L11.68 14.05c.64.64 1.48.96 2.32.96.84
      0 1.68-.32 2.32-.96L27.678 2.717c.427-.427.428-1.12.002-1.547z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconArrowDown'
}
</script>
